export const ASSIGN_LEAD = 'ASSIGN_LEAD';
export const ASSIGN_LEAD_SUCCESS = 'ASSIGN_LEAD_SUCCESS';
export const ASSIGN_LEAD_FAILURE = 'ASSIGN_LEAD_FAILURE';

export const ASSIGN_LEAD_DELIVERY_REQUESTED_AGENT = 'ASSIGN_LEAD_DELIVERY_REQUESTED_AGENT';
export const ASSIGN_LEAD_DELIVERY_REQUESTED_AGENT_SUCCESS = 'ASSIGN_LEAD_DELIVERY_REQUESTED_AGENT_SUCCESS';
export const ASSIGN_LEAD_DELIVERY_REQUESTED_AGENT_FAILURE = 'ASSIGN_LEAD_DELIVERY_REQUESTED_AGENT_FAILURE';

export const SET_LEAD_VALUATION_REQUEST = 'SET_LEAD_VALUATION_REQUEST';
export const SET_RETAIL_PRICE_REQUEST = 'SET_RETAIL_PRICE_REQUEST';



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/constants/assign_lead.constants.js